module.exports = __webpack_public_path__ + "img/Edit.25b376ca.svg";